/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Machines_RetryInputs */

const vi_tea_machines_retry = /** @type {(inputs: Tea_Machines_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thử lại`)
};

/**

* @param {Tea_Machines_RetryInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_machines_retry = /** @type {((inputs?: Tea_Machines_RetryInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Machines_RetryInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_machines_retry(inputs)
});